import React, { useContext, useState } from "react";
import { useGetSingleSubmittalsQuery } from "../../../Redux/service/Submittals/Submittals";
import { popupcontext } from "../../../context/Popupscontext";
import Popup from "../../Helpers/Popup/Popup";
import { Segmented, Tag } from "antd";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import trans from "../../../utils";
import Loader from "../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import SubmittalsInf from "./SubmittalsInf";
import { Modal } from "react-bootstrap";
import SubmittalsReview from "./SubmittalsReview";
import SubmittalsHistoryWork from "./SubmittalsHistoryWork";
import SubmittalsRevisions from "./SubmittalsRevisions";
import Button from "../../Helpers/Button/Button";
import {
	StepBackwardOutlined,
	LeftOutlined,
	RightOutlined,
	StepForwardOutlined,
} from "@ant-design/icons";

export default function SubmitalsPopup({ submittalId }) {
	const { data, isLoading, refetch } = useGetSingleSubmittalsQuery(
		submittalId,
		{
			skip: !submittalId,
		}
	);
	let { setcurrentSubmittalId, setResubmission, handleShow } =
		useContext(popupcontext);
	const [resubmit, setResubmit] = useState(false);
	const inf = useSelector((state) => state.users.user);

	const closeuser = () => {
		setcurrentSubmittalId(null);
	};
	const [activeOption, setActiveOption] = useState("information");
	const statusColors = {
		PENDING_QA: `orange`,
		PENDING_CONSULTANT: `orange`,
		APPROVED: `green`,
		REJECTED: `red`,
		REVISION_REQUIRED: `purple`,
		RETURNED_TO_CONTRACTOR: `default`,
	};
	const handleResubmit = () => {
		if (inf.attributes.role === "contractor") {
			setResubmission(true);
			handleShow("editForm", "submittal", submittalId);
		} else {
			setResubmit(true);
		}
	};

	// Revisions come embedded in GET /:id as `revisionTracking`, the same shape the IR
	// popup reads. The backend already blanks isrRevisions for consultants, so the
	// internal loop is hidden server-side as well as here.
	const tracking = data?.data?.revisionTracking;
	const isrRevisions = tracking?.isrRevisions || [];
	const esrRevisions = tracking?.esrRevisions || [];

	const [currentRevisionIndex, setCurrentRevisionIndex] = useState(null);
	const activeRevisions =
		activeOption === "isrRevisions"
			? isrRevisions
			: activeOption === "esrRevisions"
				? esrRevisions
				: null;

	const segments = [
		{ label: trans("information"), value: "information" },
		{ label: trans("review"), value: "review" },
		...(isrRevisions.length
			? [{ label: `${trans("ISR")} (${isrRevisions.length})`, value: "isrRevisions" }]
			: []),
		...(esrRevisions.length
			? [{ label: `${trans("ESR")} (${esrRevisions.length})`, value: "esrRevisions" }]
			: []),
	];

	const handleSegmentChange = (value) => {
		setActiveOption(value);
		setResubmit(false);
		// Open on the latest revision, as the IR popup does
		if (value === "isrRevisions") {
			setCurrentRevisionIndex(isrRevisions.length ? isrRevisions.length - 1 : null);
		} else if (value === "esrRevisions") {
			setCurrentRevisionIndex(esrRevisions.length ? esrRevisions.length - 1 : null);
		} else {
			setCurrentRevisionIndex(null);
		}
	};

	return (
		<Popup show={!!submittalId}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={`${
							data?.data?.submittalNumber && data?.data?.submittalNumber
						}`}
						subtitle={
							<Tag color={statusColors[data?.data?.status] || "default"}>
								{trans(data?.data?.status)}
							</Tag>
						}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeuser}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={segments}
				style={{ textTransform: "capitalize" }}
				onChange={handleSegmentChange}
				value={activeOption}
				size="large"
				block
			/>
			<Modal.Body className="modal-body-scrollable">
				{isLoading ? (
					<div className="loader-container">
						<Loader />
					</div>
				) : (
					<>
						{activeOption === "information" && (
							<SubmittalsInf values={data?.data} statusColors={statusColors} />
						)}
						{activeOption === "review" && (
							<>
								<SubmittalsHistoryWork
									history={data?.data?.history}
									resubmit={resubmit}
									setResubmit={setResubmit}
									refetch={refetch}
								/>

								{(((data?.data?.status === "RETURNED_TO_CONTRACTOR" ||
									data?.data?.status === "REVISION_REQUIRED") &&
									inf.attributes.role === "contractor") ||
									(data?.data?.status === "PENDING_QA" &&
										inf.attributes.role === "qa") ||
									(data?.data?.status === "PENDING_CONSULTANT" &&
										inf.attributes.role === "consultant")) && (
									<div
										style={{
											position: "sticky",
											bottom: 0,
											background: "#fff",
											padding: "12px 16px",
											borderTop: "1px solid #f0f0f0",
											zIndex: 10,
											display: "flex",
											justifyContent: "flex-end",
											transform: "translateY(18px)",
										}}
									>
										<Button
											danger={true}
											text={
												inf.attributes.role === "contractor"
													? trans("Resubmit")
													: trans("Next")
											}
											type="primary"
											className="d-flex ms-auto"
											onClick={handleResubmit}
										/>
									</div>
								)}
								<SubmittalsReview
									refetch={refetch}
									setResubmit={setResubmit}
									status={data?.data?.status}
									resubmit={resubmit}
								/>
							</>
						)}
						{activeRevisions && (
							<SubmittalsRevisions
								data={activeRevisions}
								currentRevisionIndex={currentRevisionIndex}
								statusColors={statusColors}
							/>
						)}
					</>
				)}
			</Modal.Body>
			{activeRevisions?.length > 0 && currentRevisionIndex !== null && (
				<Modal.Footer className="d-flex justify-content-between align-items-center">
					<div className="d-flex gap-2">
						<Button
							text={<><StepBackwardOutlined /> {trans("First")}</>}
							type="default"
							disabled={currentRevisionIndex === 0}
							onClick={() => setCurrentRevisionIndex(0)}
						/>
						<Button
							text={<><LeftOutlined /> {trans("Previous")}</>}
							type="default"
							disabled={currentRevisionIndex === 0}
							onClick={() => setCurrentRevisionIndex(currentRevisionIndex - 1)}
						/>
					</div>
					<div className="text-muted">
						{trans("Revision")} {currentRevisionIndex + 1} {trans("of")}{" "}
						{activeRevisions.length}
					</div>
					<div className="d-flex gap-2">
						<Button
							text={<>{trans("Next")} <RightOutlined /></>}
							type="default"
							disabled={currentRevisionIndex === activeRevisions.length - 1}
							onClick={() => setCurrentRevisionIndex(currentRevisionIndex + 1)}
						/>
						<Button
							text={<>{trans("Last")} <StepForwardOutlined /></>}
							type="default"
							disabled={currentRevisionIndex === activeRevisions.length - 1}
							onClick={() => setCurrentRevisionIndex(activeRevisions.length - 1)}
						/>
					</div>
				</Modal.Footer>
			)}
		</Popup>
	);
}
